import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Notifications } from "@mantine/notifications";

import "./App.css";

import LoginPage from "./pages/login/components/organims/LoginPage";
import { Dashboard } from "./pages/dashboard/components/orgnims/Dashboard";
import { RecruitmentPage } from "./pages/form/component/orgnims/RecruitmentPage";
import { Inbox } from "./pages/inbox/components/orgnims/Inbox";
import { Sent } from "./pages/sent/components/orgnims/Sent";
import TablePages from "./pages/tables/components/orgnims/TablePages";
import ShortlistPage from "./pages/shortlisting/components/orgnims/ShortlistPage";
import MarksPage from "./pages/marks/components/orgnims/MarksPage";
import { RequestPage } from "./pages/requestform/components/organims/RequestPage";
import ArchivedPage from "./pages/Archived/components/organims/ArchivedPage";
import CandidatePage from "./pages/candidates/components/organims/CandidatePage";
import PendingPage from "./pages/Pending/orgnims/PendingPage";
import { Sidebar } from "./pages/dashboard/components/orgnims/Sidebar";
import { Header } from "./pages/dashboard/components/orgnims/Header";
import CareerFormPage from "./pages/vacancy/component/orgnims/CareerFormPage";
import JobListingPage from "./pages/careers/components/orgamins/JobListingPage";
import JobDetailsPage from "./pages/details/component/orgnims/JobDetailsPage";
import ApprovalPage from "./pages/approval/components/organisms/ApprovalPage";
import Candidatelist from "./pages/candidateDetails/components/orgnisms/Candidatelist";
import { CandidateDashboard } from "./pages/viewcandidates/components/organisms/CandidateDashboard";
import { ExamPage } from "./pages/exam/components/organims/ExamPage";
import ApplicationForm from "./pages/Apply/components/orgamins/ApplicationForm";

import {
  OngoingHiresTablePage,
  CompletedHiresTablePage,
  DiscardedHiresTablePage,
} from "./pages/dashboard/components/orgnims/SummaryItemsPage";

// MTN header logo (ensure this file exists: src/assets/brand/mtn-logo.jpg)
import mtnLogo from "./assets/brand/mtn-logo.jpg";

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

const DashboardLayout = () => (
  <div className="flex h-screen overflow-hidden bg-gray-100">
    <Sidebar />
    <div className="flex flex-col flex-1 h-screen ml-auto">
      <Header logoSrc={mtnLogo} logoAlt="MTN" />
      <main className="flex flex-col flex-1 h-full">
        <Outlet />
      </main>
    </div>
  </div>
);

function App() {
  // Page title; favicon is set in public/index.html
  useEffect(() => {
    document.title = "MTN Recruitment";
  }, []);

  return (
    <Router>
      <Notifications position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/apply/:jobid" element={<ApplicationForm />} />
        <Route path="/career" element={<JobListingPage />} />
        <Route path="/jobs/:jobId" element={<JobDetailsPage />} />

        {/* Protected routes (dashboard layout) */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/recruitment" element={<RecruitmentPage />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/sent" element={<Sent />} />
            <Route
              path="/CandDashboard/:candidateId"
              element={<CandidateDashboard />}
            />
            <Route path="/tables" element={<TablePages />} />
            <Route path="/shortlist/:jobId" element={<ShortlistPage />} />
            <Route path="/marks" element={<MarksPage />} />
            <Route path="/exam" element={<ExamPage />} />
            <Route path="/requests/:id" element={<RequestPage />} />
            <Route path="/archive" element={<ArchivedPage />} />
            <Route path="/jobs/:jobId/candidates" element={<CandidatePage />} />
            <Route path="/pending" element={<PendingPage />} />
            <Route path="/approval" element={<ApprovalPage />} />

            {/* Create vacancy (existing) */}
            <Route path="/vacancy/:requestId" element={<CareerFormPage />} />

            {/* ✅ Edit posted job -> same form page, but it will prefill by jobId */}
            <Route path="/career/edit/:jobId" element={<CareerFormPage />} />

            <Route path="/candidate" element={<Candidatelist />} />
            <Route
              path="/requests/ongoing-hires"
              element={<OngoingHiresTablePage />}
            />
            <Route
              path="/requests/completed-hires"
              element={<CompletedHiresTablePage />}
            />
            <Route
              path="/requests/discarded-hires"
              element={<DiscardedHiresTablePage />}
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
